/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconArrowBackUp = createReactComponent("arrow-back-up", "IconArrowBackUp", [
  ["path", { d: "M9 14l-4 -4l4 -4", key: "svg-0" }],
  ["path", { d: "M5 10h11a4 4 0 1 1 0 8h-1", key: "svg-1" }]
]);

export { IconArrowBackUp as default };
//# sourceMappingURL=IconArrowBackUp.js.map
